
























/* 
thanks https://css-tricks.com/building-a-donut-chart-with-vue-and-svg/
*/
import Vue from "vue";
import { computed } from "@vue/composition-api";
export default Vue.extend({
  props: ["offset", "color"],
  setup(props) {
    const circumference = 2 * 69.85699 * Math.PI;
    const dashoffset = computed(() => {
      const strokeDiff = (props.offset as number) * 0.01 * circumference;
      return circumference - strokeDiff;
    });
    return { circumference, dashoffset };
  }
});
